import { Button, Card, Col, Image } from "antd";
import { PlusIcon, SearchIcon } from "../../../../../atoms/CustomIcons";

export default function RightSideBar() {
  return (
    <Col flex="360px">
      <Card className="right_inner">
        <h6> General details </h6>

        <div className="widgetCard" style={{ marginBottom: "24px" }}>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Account manager:</h6>
            <h6 className="miniDetail">
              <img
                src="/images/potential-deals/avatar.png"
                alt=""
                style={{
                  borderRadius: "100px",
                  width: "20px",
                  height: "20px",
                }}
              />
              David L.
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Type of sale</h6>
            <h6 className="miniDetail">Base contract</h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Production manager:</h6>
            <h6 className="miniDetail">
              <img
                src="/images/dummy/checkList_dp_1.png"
                alt=""
                style={{
                  borderRadius: "100px",
                  width: "20px",
                  height: "20px",
                }}
              />
              Jack B.
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Crew:</h6>
            <h6 className="miniDetail">CN 1 - Asher L.</h6>
          </div>
        </div>
      </Card>
      <Card className="right_inner">
        <h6> Contract terms </h6>
        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Start date </h6>
            <h6 className="miniDetail"> April 10, 2025 </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> End date </h6>
            <h6 className="miniDetail"> Oct 14, 2025 </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Renewable </h6>
            <h6 className="miniDetail"> No </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Pricing model </h6>
            <h6 className="miniDetail"> Fixed price </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Billing </h6>
            <h6 className="miniDetail"> Per milestone </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Net terms </h6>
            <h6 className="miniDetail"> Net 30 </h6>
          </div>
        </div>
      </Card>
      <Card
        className="profileSidebar"
        onClick={() =>
          window.open(
            "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
            "_blank"
          )
        }
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Drawings</span>
            </div>
            <div className="documentImage cs_tmp_image">
              <Image src="/images/dummy/con_img_1.png" preview={false} />
            </div>
          </Card>
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Proposals</span>
            </div>
            <div className="documentImage cs_tmp_image">
              <Image src="/images/dummy/con_img_2.png" preview={false} />
            </div>
          </Card>
        </div>
      </Card>
    </Col>
  );
}
